export default __webpack_public_path__ + "static/media/mdt.71adc4a2.PNG";